module.exports = __webpack_public_path__ + "fonts/4fba38e724f7a75219b1074382ac8d72.svg";